<template>
  <SfInput
    v-model="value"
    :align="align"
    :focused="focused"
    :disabled="disabled"
    :hide-browser-appearance="true"
    :error-text="error"
    :error-style="'seamless'"
    :required="required"
    min="0"
    step="0.01"
    @blur="handleBlur"
    @keyup="handleKeyup"
  />
</template>

<script setup lang="ts" generic="MV">
import type { SubAdjustmentRow } from '../types'

import { useVModel } from '@vueuse/core'

import SfInput from '@app/shared/vue/components/sf-input/sf-input.vue'
import { useAdjustmentsModalStore } from '@app/application/adjustments/store/adjustment-modal'

interface Props {
  align?: 'left' | 'right'
  disabled?: boolean
  focused?: number
  error?: string
  required?: boolean
  type?: 'text' | 'number'
  id: string | number
  valueKey: keyof SubAdjustmentRow
  modelValue?: MV
}

const props = withDefaults(defineProps<Props>(), {
  align: 'left',
  focused: 0,
  error: '',
  type: undefined,
  modelValue: undefined,
})

const emit =
  defineEmits<{
    focus: [column: keyof SubAdjustmentRow]
    'update:modelValue': [value: MV]
  }>()

const value = useVModel(props, 'modelValue', emit)
const modalStore = useAdjustmentsModalStore()
const { convertMathExpressionToNumber } = modalStore

const handleBlur = () => {
  if (props.type !== 'number') {
    return
  }
  convertMathExpressionToNumber(props.id, props.valueKey)
}

const handleKeyup = () => {
  modalStore.markColumnEdited(props.id.toString(), props.valueKey)
}
</script>
